import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  HStack,
  Icon,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "phosphor-react";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <Box minH="100vh" bg="gray.900" py={20}>
      <Container maxW="container.md">
        <VStack spacing={8} align="stretch">
          <HStack spacing={4}>
            <Button
              leftIcon={<Icon as={ArrowLeft} weight="bold" />}
              variant="ghost"
              color="white"
              onClick={() => navigate("/")}
              _hover={{ bg: "whiteAlpha.200" }}
            >
              Back to home
            </Button>
          </HStack>

          <Heading color="white" textAlign="center" size="2xl" mb={8}>
            Privacy policy
          </Heading>

          <VStack spacing={8} align="stretch">
            <Box>
              <Text color="gray.300" fontSize="lg">
                At Virtual Golf Society, we take your privacy seriously. This
                policy describes how we collect, use, and protect your
                information.
              </Text>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                Information we collect
              </Heading>
              <Text color="gray.300" mb={4}>
                We may collect information you provide directly to us when you
                create an account or use our services, including:
              </Text>
              <UnorderedList color="gray.300" spacing={2} pl={4}>
                <ListItem>Email address</ListItem>
                <ListItem>Profile details you choose to share</ListItem>
                <ListItem>
                  Content you post (e.g. rounds, images, links)
                </ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                How we use your information
              </Heading>
              <UnorderedList color="gray.300" spacing={2} pl={4}>
                <ListItem>To provide and operate the platform</ListItem>
                <ListItem>
                  To communicate important updates and support
                </ListItem>
                <ListItem>To improve features and user experience</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                Data protection
              </Heading>
              <Text color="gray.300">
                We use reasonable technical and organizational measures to help
                protect your information. No method of transmission or storage
                is completely secure.
              </Text>
            </Box>

            <Box>
              <Heading color="white" size="md" mb={4}>
                Contact us
              </Heading>
              <Text color="gray.300">
                If you have questions about this privacy policy, please contact
                us at privacy@joinvgs.com
              </Text>
            </Box>
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default Privacy;
